import type { BaseComponentProps, WithChildren } from "@neru/types";

interface ColumnProps extends BaseComponentProps, WithChildren {}

export const Column = ({
  children,
  className = "",
  "data-testid": testId,
  style,
}: ColumnProps) => (
  <div
    className={`
      flex flex-col

      ${className}
    `}
    data-testid={testId}
    style={style}
  >
    {children}
  </div>
);
